function CTASection({ onSignup, onBookDemo }) {
  return (
    <section className="cta-section">
      <div className="cta-inner">
        <h2>Ready to see QAP Financials in action?</h2>
        <p>
          Get instant, consolidated financial insight across all your
          entities — without spreadsheets, without the manual rollup, and
          without waiting until month-end to know where you stand.
        </p>

        <div className="hero-actions">
          <button className="primary-btn" onClick={onSignup}>
            Sign Up Free
          </button>

          <button className="secondary-btn" onClick={onBookDemo}>
            Talk to Us
          </button>
        </div>
      </div>
    </section>
  );
}

export default CTASection;
